import _ from "lodash";
import { ITransfer, ILocalStateUpdateResult, IVirtualTrip, ITransferTask } from "../../common/plannerTypes";

const getShortFullName = (firstName: string | null, lastName: string): string => `${firstName ? firstName.charAt(0) : ""} ${lastName}`;

const isTransfersNotChanged = (oldTransfers: ITransfer[], newTransfers: ITransfer[]): boolean => {
    for (let index = 0; index < oldTransfers.length; index++) {
        const oldTransfer = oldTransfers[index];
        const newTransfer = newTransfers.find(nt => nt.transferId === oldTransfer.transferId);
        if(newTransfer &&
        oldTransfer.scheduleObj.status !== oldTransfer.scheduleObj.status && 
        oldTransfer.scheduleObj.tripPlannerId !== oldTransfer.scheduleObj.tripPlannerId &&
        oldTransfer.scheduleObj.scheduledDate !== oldTransfer.scheduleObj.scheduledDate && 
        oldTransfer.scheduleObj.estimatedDurationInMunutes !== oldTransfer.scheduleObj.estimatedDurationInMunutes){
            return false;
        }
    }
    return true;
}

const isTransferTasksNotChanged = (oldTransferTasks: ITransferTask[], newTransferTasks: ITransferTask[]): boolean => {
    for (let index = 0; index < oldTransferTasks.length; index++) {
        const oldTransferTask = oldTransferTasks[index];
        const newTransferTask = newTransferTasks[index];
        if(oldTransferTask.transferId !== newTransferTask.transferId &&
            oldTransferTask.taskType !== newTransferTask.taskType &&
            oldTransferTask.startTime?.toISOString() !== newTransferTask.startTime?.toISOString()){
            return false;
        }
    }
    return true;
}


const isNotChanged = (oldTrip: IVirtualTrip, newTrip: IVirtualTrip): boolean =>
    oldTrip.virtualTripId === newTrip.virtualTripId &&
    oldTrip.tripPlannerId === newTrip.tripPlannerId &&
    oldTrip.startTrip.toISOString() === newTrip.startTrip.toISOString() &&
    oldTrip.endTrip.toISOString() === newTrip.endTrip.toISOString() &&
    oldTrip.isMultiLoaded === newTrip.isMultiLoaded &&
    oldTrip.transfers.length === newTrip.transfers.length &&
    oldTrip.transferTasks.length === newTrip.transferTasks.length && 
    oldTrip.isTripMinOverrided === newTrip.isTripMinOverrided &&
    isTransferTasksNotChanged(oldTrip.transferTasks, newTrip.transferTasks) &&
    isTransfersNotChanged(oldTrip.transfers, newTrip.transfers);


const updateLocalState = (localState: IVirtualTrip[], 
    oldGlobalState: IVirtualTrip[], 
    newGlobalState: IVirtualTrip[]): ILocalStateUpdateResult => {
    // find what is changed/deleted on for global state
    const changedGlobalTrips = _.differenceWith(oldGlobalState, newGlobalState, isNotChanged)
    const newTrips = newGlobalState.filter(ngs => !oldGlobalState.find(ogs => ogs.virtualTripId === ngs.virtualTripId));
    changedGlobalTrips.push(...newTrips);
    // delete trips above from local state
    const changedTrasferIds = changedGlobalTrips.flatMap((cgt) => cgt.transfers).map((q) => q.transferId);
    const tripLocalToDelete = [];
    const updatedState = [];
    for (const trip of localState) {
        const tripToDelete = trip.transfers.find(tr => changedTrasferIds.find(ct => ct === tr.transferId));
        //changedGlobalTrips.find(c => c.virtualTripId === trip.virtualTripId);
        if(tripToDelete){
            tripLocalToDelete.push(trip);
        }else{
            updatedState.push(trip);
        }
    }
    const changedNames = tripLocalToDelete.map(c => c.transfers
        .map(tr => getShortFullName(tr.scheduleObj.firstName, tr.scheduleObj.lastName)).join(', ')
        ).join(', ');

    return{
        isLocalStateChanged: tripLocalToDelete.length > 0,
        updatedState: updatedState,
        changedNames: changedNames
    }
}

const mergeLocalAndGlobalStates = (localState: IVirtualTrip[], globalState: IVirtualTrip[]): IVirtualTrip[] => {
    const mergedState = _.unionBy(localState, globalState, 'virtualTripId')
    return mergedState;
};

export {
    updateLocalState,
    mergeLocalAndGlobalStates
}